import styled, {css} from 'styled-components'

export const StyledPrivateLayout = styled.div(
    ({theme: {palette}}) => css`
        background-color: ${palette.neutral[50]};
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        height: 100%;
        overflow: hidden;
    `
)

/**
 * The content column: the work-context bar's row on top, the routed page below.
 *
 * Must stay a plain grid container — no transform/filter/opacity/will-change — or it would
 * create a stacking context and trap the bar's z-index below the app's overlays.
 */
export const StyledPrivateLayoutContent = styled.div(
    () => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        height: 100%;
        overflow: hidden;
    `
)
